import React from 'react';
import BarGraph from 'components/Charts/BarGraph';
import Tooltip from 'modules/Prices/components/tooltip';
import { getLabels, roundDecimal, roundValue } from 'modules/Prices/helpers';
import { getChartData } from 'modules/Prices/pages/price/components/GraphByNetworks/helpers';

import { components } from 'apiTyped/types';
import { MarketOption } from 'interface';

const PriceNetworkChart = ({
  data,
  activeRadioButton,
  currency,
  market,
  wine,
  vintage,
  format,
  competitor,
  competitorVintage
}: {
  data: components['schemas']['DataDetail'][];
  activeRadioButton: string;
  currency: string;
  market: MarketOption | null;
  wine: string | null;
  vintage: string | null;
  format: string | null;
  competitor: string | null;
  competitorVintage?: string | null;
}) => {
  const dataChart = getChartData({
    data,
    wine,
    vintage,
    format,
    market,
    activeRadioButton,
    currency,
    competitor,
    competitorVintage
  });

  const labels = getLabels(dataChart, activeRadioButton, true);

  return (
    <BarGraph
      data={dataChart}
      isAnimationActive={false}
      height={450}
      tooltipOffset={{
        x: -80,
        y: dataChart.length * -20
      }}
      renderTooltip={(props: any) => (
        <Tooltip data={props} labels={labels} currency={currency} />
      )}
      colors={['#d35736', '#1f2b37']}
      labels={labels}
      showLabel
      yAxisProps={{
        type: 'number',
        scale: 'linear',
        domain: [
          0,
          (dataMax: number) => roundDecimal(dataMax + dataMax / 5, -1)
        ],
        tickFormatter: (value: any) =>
          roundValue(value, 10).toLocaleString('fr-FR', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })
      }}
    />
  );
};

export default PriceNetworkChart;
